export default {
  // list
  total: 0,
  pages: 1,
  page: 1,
  limit: 10,
  sortBy: 'id',
  sortDesc: true,
  list: [],

  // search
  conditions: {
    created_at_start: '',
    created_at_end: '',
    users: ['my', 'other'],
    subject: '',
    message: '',
  },

  // edit
  form: {
    id: null,
    number: null,
    subject: '',
    message: '',
    is_send: false,
  },
};
